import httpClient from '@api/httpClient'
import type { PackagingType } from '@models/packaging'
import { packagingUrls } from './constants'

const getPackagingTypes = async (companyId: number) => {
  const { data } = await httpClient.get<PackagingType[]>(
    packagingUrls.root(companyId),
    { params: { companyId } },
  )
  return data
}

export interface CreatePackagingTypeRequestData {
  companyId: number
  packagingTypeExternalId: string
  name: string
}

const createPackagingType = async ({
  companyId,
  ...props
}: CreatePackagingTypeRequestData) => {
  const { data } = await httpClient.post<PackagingType>(
    packagingUrls.root(companyId),
    props,
  )
  return data
}

export interface UpdatePackagingTypeRequestData {
  id: number
  companyId: number
  name: string
}

const updatePackagingType = async ({
  companyId,
  id,
  ...props
}: UpdatePackagingTypeRequestData) => {
  const { data } = await httpClient.patch<PackagingType>(
    packagingUrls.packagingType(companyId, id),
    props,
  )
  return data
}

export interface DeletePackagingTypeRequestData {
  companyId: number
  id: number
}

const deletePackagingType = async ({
  companyId,
  id,
}: DeletePackagingTypeRequestData) => {
  const { data } = await httpClient.delete(
    packagingUrls.packagingType(companyId, id),
  )
  return data
}

export default {
  getPackagingTypes,
  createPackagingType,
  updatePackagingType,
  deletePackagingType,
}
